import axios from 'axios'
import { Request } from '@/domain/Request'

/**
 * 検索条件
 */
export class SerchConditon {
    /** 受付番号 */
    requestNo = ""
    /** 顧客都道府県コード */
    customerPrefectureCode = ""
    /** 顧客コード */
    customerCode = ""
    /** 顧客枝番 */
    customerBranchNumber = ""
    /** 顧客名 */
    customerName = ""
    /** 検査依頼種別 */
    requestType: number | null = null
    /** 備考 */
    note = ""
    /* 有効 */
    isActive = true

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SerchConditon>) {
        Object.assign(this, init)
    }
}

/**
 * 検査開始日情報
 */
export class InspectionInfo {
    /** 検査開始日 */
    inspectionOn = ""
    /** 検査開始ユーザID */
    inspectionUserId = ""
    /** 検査開始ユーザー */
    inspectionUserName = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<InspectionInfo>) {
        Object.assign(this, init)
    }
}

/**
 * 検査開始
 */
export class InspectionStart {
    /** 受付番号 */
    requestNos: string[] = []
    /** 検査開始日 */
    inspectionOn = ""
    /** 検査開始ユーザID */
    inspectionUserId = ""
    /** 検査開始ユーザー */
    inspectionUserName = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<InspectionStart>) {
        Object.assign(this, init)
    }
}

/**
 * 未検査一覧サービス
 */
export default class UninspectedsService {
    /** インスタンス */
    private static _instance: UninspectedsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new UninspectedsService();
        }
        return this._instance;
    }

    /**
     * 未検査一覧を検索
     */
    public async findAll(serchConditon: SerchConditon): Promise<Request[]> {
        return await axios.get("/api/inspects/uninspected", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Request[]).map(x => new Request({ ...x }))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 検査開始日登録
     */
    public async updateInspectOn(requestNos: string[], inspectionInfo: InspectionInfo): Promise<Request> {
        const inspectionStart = new InspectionStart({requestNos: requestNos, inspectionOn: inspectionInfo.inspectionOn, inspectionUserId: inspectionInfo.inspectionUserId, inspectionUserName: inspectionInfo.inspectionUserName})
        return await axios.put("/api/inspect/inspection_on", inspectionStart)
            .then((results) => {
                if (results.status === 200) {
                    return new Request({ ...results.data })
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
